const OUTREACH_CATEGORY = 'outreach'

export const OUTREACH_EVENTS = {
  CLOSE_POPUP: {
    action: 'Close outreach popup',
    category: OUTREACH_CATEGORY,
  },
  ASK_AGAIN_LATER: {
    action: 'Ask again later',
    category: OUTREACH_CATEGORY,
  },
  OPEN_SURVEY: {
    action: 'Open outreach survey',
    category: OUTREACH_CATEGORY,
  },
}
